import type { FaireProductEntity } from "../../entity_types/product";

export const p_hn7zh5tvd9: FaireProductEntity = {
  token: "p_hn7zh5tvd9",
  type: "product",
  name: "Mini: Manak\u014d x Mango Chocolate Bar",
  brandName: "Manoa Chocolate Hawaii",
  imageUrl:
    "https://cdn.faire.com/fastly/3ceac414c9564b629f142f471f6d237f17c576475857c1cca57809db0a0f421e.jpeg",
  priceDollars: 2.99,
  description: "",
  categoryTokens: ["cat_accessories"],
  tags: [],
  meta: {
    source: "mock",
    importedAt: "2026-03-24T13:23:30Z",
    importedBy: "retailerThemesSeed-migration",
  },
  freeShipping: true,
  brandAvatarUrl:
    "https://cdn.faire.com/fastly/a2ea5d4664dbed8a94e1c3be5abd39796810507abe8f2143aa716d4ca407dd1e.jpeg",
  weight: 0.5,
  dimensions: {
    width: 4,
    height: 4,
    depth: 2,
  },
  inStock: true,
};
